import {loop, Effects} from 'redux-loop';
import _ from 'lodash';
import { TOGGLE_ADVANCED_MODAL } from './actions';

const initialState = {
  isOpen: false,
}

export default (state = initialState, action) => {

  if (action.type === TOGGLE_ADVANCED_MODAL) {
    return loop({
      ...state,
      isOpen: !state.isOpen
    },
      Effects.none()
    )
  }

  return loop(state, Effects.none())
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/advancedSearch/reducer.js
 **/